// extracted by mini-css-extract-plugin
module.exports = {"success-container":"configure_page__success-container___2y5om","success-circle":"configure_page__success-circle___3AmsM","bounce-in":"configure_page__bounce-in___3cQfY"};